import { render, staticRenderFns } from "./Budget_4_09.vue?vue&type=template&id=e52326fe&scoped=true&"
import script from "./Budget_4_09.vue?vue&type=script&lang=js&"
export * from "./Budget_4_09.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52326fe",
  null
  
)

export default component.exports